import animatorMixin from '@/mixins/animatorMixin'
import { styler, tween, timeline } from 'popmotion'

export default {
    mixins: [animatorMixin],

    computed: {
        // Grid line elements
        horizontalLineElements: vm =>
            Array.from(vm.rootElement.querySelectorAll('.horizontal-lines')),
        verticalLineElements: vm =>
            Array.from(vm.rootElement.querySelectorAll('.vertical-lines')),
        // backgroundElement: vm =>
        // vm.rootElement.querySelector('#background-cover'),

        stylers() {
            return {
                horizontal: this.horizontalLineElements.map(e => styler(e)),
                vertical: this.verticalLineElements.map(e => styler(e)),
                // background: styler(this.backgroundElement),
                root: styler(this.rootElement)
            }
        },

        action() {
            return timeline([
                { track: 'line', from: 0, to: 100, duration: 2000 },
                '-300',
                { track: 'root', from: 1, to: 0, duration: 600 }
            ])
        },

        reaction() {
            return value => {
                this.stylers.horizontal.forEach(styler =>
                    styler.set({ pathLength: value.line })
                )
                this.stylers.vertical.forEach(styler =>
                    styler.set({ pathLength: value.line })
                )
                // this.stylers.background.set({ opacity: value.background })
                this.stylers.root.set({ opacity: value.root })
            }
        }
    },

    mounted() {
        this.init()
    },

    methods: {
        init() {
            this.stylers.horizontal.forEach(styler =>
                styler.set({ pathLength: 0 })
            )
            this.stylers.vertical.forEach(styler =>
                styler.set({ pathLength: 0 })
            )
        },

        start() {
            this.action.start({
                update: this.reaction,
                complete: this.complete
            })
        },

        complete() {
            this.$emit('complete', 'grid')
        }
    }
}
